if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();

        // this.hiddenControlField = this.querySelector(
        //   `#Recipient-Control-${this.dataset.sectionId}`,
        // );
        // this.hiddenControlField.disabled = true;

        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`,
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`,
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`,
        );
        this.senderNameInput = this.querySelector(
          `#Recipient-sender-name-${this.dataset.sectionId}`,
        );
        this.emailSubjectInput = this.querySelector(
          `#Recipient-email-subject-${this.dataset.sectionId}`,
        );
        this.checkboxInput = this.querySelector(`input[type="checkbox"]`);
        this.errorMessageWrapper = this.querySelector(
          ".product-form__recipient-error-message-wrapper",
        );
        this.errorMessageList = this.errorMessageWrapper?.querySelector("ul");
        this.errorMessage =
          this.errorMessageWrapper?.querySelector(".error-message");
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener("change", this.onChange.bind(this));
      }

      connectedCallback() {
        document.addEventListener(
          "cart:item-added",
          this.onCartAdded.bind(this),
        );
        document.addEventListener(
          "product:variant-change",
          this.onVariantChange.bind(this),
        );
        document.addEventListener(
          "product:variant-error",
          this.onVariantError.bind(this),
        );

        // Initialize form validation
        this.initFormValidation();
      }

      onCartAdded(event) {
        if (
          event.detail.product.id.toString() === this.currentProductVariantId
        ) {
          this.resetRecipientForm();
        }
      }
      onVariantChange(event) {
        if (event.detail.sectionId === this.dataset.sectionId) {
          this.currentProductVariantId = event.detail.variant.id.toString();
        }
      }
      onVariantError(event) {
        if (
          event.detail.source === "product-form" &&
          event.detail.productVariantId.toString() ===
            this.currentProductVariantId
        ) {
          this.displayErrorMessage(event.detail.message, event.detail.errors);
        }
      }

      onChange() {
        if (this.checkboxInput && !this.checkboxInput.checked) {
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }

      clearInputFields() {
        this.emailInput.value = "";
        this.nameInput.value = "";
        this.messageInput.value = "";
        this.senderNameInput.value = "";
        this.emailSubjectInput.value = "";
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === "object") {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const placeholderElement = this.querySelector(`${fieldSelector}`);
            const label =
              placeholderElement?.getAttribute("placeholder") || key;
            const message = `${label} ${value}`;
            const errorMessageElement = this.querySelector(
              `#${errorMessageId}`,
            );
            const errorTextElement =
              errorMessageElement?.querySelector(".error-message");
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(
                this.createErrorListItem(fieldSelector, message),
              );
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove("hidden");

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute("aria-invalid", true);
            inputElement.setAttribute("aria-describedby", errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.setAttribute("href", target);
        a.innerText = message;
        li.appendChild(a);
        li.className = "error-message";
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = "";

        this.querySelectorAll(".recipient-fields .form__message").forEach(
          (field) => {
            field.classList.add("hidden");
            const textField = field.querySelector(".error-message");
            if (textField) textField.innerText = "";
          },
        );

        [this.emailInput, this.messageInput, this.nameInput].forEach(
          (inputElement) => {
            inputElement.setAttribute("aria-invalid", false);
            inputElement.removeAttribute("aria-describedby");
          },
        );
      }

      resetRecipientForm() {
        if (this.checkboxInput && this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }

      // Form validation methods
      initFormValidation() {
        // Find the parent product form
        this.parentForm = this.closest('form[action*="/cart/add"]');
        if (!this.parentForm) return;

        // Listen for form submission
        this.parentForm.addEventListener(
          "submit",
          this.onFormSubmit.bind(this),
        );

        // Initialize field validations
        this.initEmailValidation();
        this.initNameValidation();
        this.initMessageValidation();
        this.initSenderNameValidation();
        this.initEmailSubjectValidation();
      }

      onFormSubmit(event) {
        // Only validate if recipient form is visible/active
        if (!this.isRecipientFormActive()) return;

        const isValid = this.validateAllFields();
        if (!isValid) {
          event.preventDefault();
          event.stopPropagation();
        }
      }

      isRecipientFormActive() {
        // Check if recipient form is visible and should be validated
        // This could be based on a checkbox, visibility, or other logic
        const recipientContainer =
          this.closest(".recipient-form-container") || this;
        return (
          !recipientContainer.hidden &&
          recipientContainer.style.display !== "none" &&
          (this.checkboxInput ? this.checkboxInput.checked : true)
        );
      }

      validateAllFields() {
        let isValid = true;

        // Clear any existing validation errors
        this.clearValidationErrors();

        // Validate each required field
        if (this.emailInput?.hasAttribute("required")) {
          if (!this.validateEmailField()) isValid = false;
        }

        if (this.nameInput?.hasAttribute("required")) {
          if (!this.validateNameField()) isValid = false;
        }

        if (this.messageInput?.hasAttribute("required")) {
          if (!this.validateMessageField()) isValid = false;
        }

        if (this.senderNameInput?.hasAttribute("required")) {
          if (!this.validateSenderNameField()) isValid = false;
        }

        if (this.emailSubjectInput?.hasAttribute("required")) {
          if (!this.validateEmailSubjectField()) isValid = false;
        }

        return isValid;
      }

      initEmailValidation() {
        if (!this.emailInput) return;

        const emailField = this.emailInput.closest(".field");
        const emailErrorMessage = this.createErrorMessageSpan(emailField);

        this.emailInput.addEventListener("blur", () => {
          this.validateEmailField();
        });

        this.emailInput.addEventListener("input", () => {
          // Clear errors on input if field becomes valid
          if (this.emailInput.validity.valid && this.emailInput.value.trim()) {
            this.clearFieldError(
              this.emailInput,
              emailField,
              emailErrorMessage,
            );
          }
        });
      }

      validateEmailField() {
        if (!this.emailInput) return true;

        const emailField = this.emailInput.closest(".field");
        const emailErrorMessage = this.createErrorMessageSpan(emailField);

        this.emailInput.setCustomValidity("");

        if (
          this.emailInput.hasAttribute("required") &&
          !this.emailInput.value.trim()
        ) {
          return this.setFieldError(
            this.emailInput,
            emailField,
            emailErrorMessage,
            "Recipient email is required.",
          );
        } else if (
          this.emailInput.value.trim() &&
          this.emailInput.validity.typeMismatch
        ) {
          return this.setFieldError(
            this.emailInput,
            emailField,
            emailErrorMessage,
            "Please enter a valid email address.",
          );
        } else {
          this.clearFieldError(this.emailInput, emailField, emailErrorMessage);
          return true;
        }
      }

      initNameValidation() {
        if (!this.nameInput) return;

        const nameField = this.nameInput.closest(".field");
        const nameErrorMessage = this.createErrorMessageSpan(nameField);
        const maxLength = 50; // Adjust as needed

        this.nameInput.addEventListener("blur", () => {
          this.validateNameField();
        });

        this.nameInput.addEventListener("input", () => {
          if (
            this.nameInput.value.length <= maxLength &&
            this.nameInput.value.trim()
          ) {
            this.clearFieldError(this.nameInput, nameField, nameErrorMessage);
          }
        });
      }

      validateNameField() {
        if (!this.nameInput) return true;

        const nameField = this.nameInput.closest(".field");
        const nameErrorMessage = this.createErrorMessageSpan(nameField);
        const maxLength = 50;

        this.nameInput.setCustomValidity("");

        if (
          this.nameInput.hasAttribute("required") &&
          !this.nameInput.value.trim()
        ) {
          return this.setFieldError(
            this.nameInput,
            nameField,
            nameErrorMessage,
            "Recipient name is required.",
          );
        } else if (this.nameInput.value.length > maxLength) {
          return this.setFieldError(
            this.nameInput,
            nameField,
            nameErrorMessage,
            `Recipient name cannot exceed ${maxLength} characters.`,
          );
        } else {
          this.clearFieldError(this.nameInput, nameField, nameErrorMessage);
          return true;
        }
      }

      initMessageValidation() {
        if (!this.messageInput) return;

        const messageField = this.messageInput.closest(".field");
        const messageErrorMessage = this.createErrorMessageSpan(messageField);
        const maxLength = 500; // Adjust as needed

        this.messageInput.addEventListener("blur", () => {
          this.validateMessageField();
        });

        this.messageInput.addEventListener("input", () => {
          if (
            this.messageInput.value.length <= maxLength &&
            (!this.messageInput.hasAttribute("required") ||
              this.messageInput.value.trim())
          ) {
            this.clearFieldError(
              this.messageInput,
              messageField,
              messageErrorMessage,
            );
          }
        });
      }

      validateMessageField() {
        if (!this.messageInput) return true;

        const messageField = this.messageInput.closest(".field");
        const messageErrorMessage = this.createErrorMessageSpan(messageField);
        const maxLength = 500;

        this.messageInput.setCustomValidity("");

        if (
          this.messageInput.hasAttribute("required") &&
          !this.messageInput.value.trim()
        ) {
          return this.setFieldError(
            this.messageInput,
            messageField,
            messageErrorMessage,
            "Message is required.",
          );
        } else if (this.messageInput.value.length > maxLength) {
          return this.setFieldError(
            this.messageInput,
            messageField,
            messageErrorMessage,
            `Message cannot exceed ${maxLength} characters.`,
          );
        } else {
          this.clearFieldError(
            this.messageInput,
            messageField,
            messageErrorMessage,
          );
          return true;
        }
      }

      initSenderNameValidation() {
        if (!this.senderNameInput) return;

        const senderNameField = this.senderNameInput.closest(".field");
        const senderNameErrorMessage =
          this.createErrorMessageSpan(senderNameField);
        const maxLength = 50;

        this.senderNameInput.addEventListener("blur", () => {
          this.validateSenderNameField();
        });

        this.senderNameInput.addEventListener("input", () => {
          if (
            this.senderNameInput.value.length <= maxLength &&
            (!this.senderNameInput.hasAttribute("required") ||
              this.senderNameInput.value.trim())
          ) {
            this.clearFieldError(
              this.senderNameInput,
              senderNameField,
              senderNameErrorMessage,
            );
          }
        });
      }

      validateSenderNameField() {
        if (!this.senderNameInput) return true;

        const senderNameField = this.senderNameInput.closest(".field");
        const senderNameErrorMessage =
          this.createErrorMessageSpan(senderNameField);
        const maxLength = 50;

        this.senderNameInput.setCustomValidity("");

        if (
          this.senderNameInput.hasAttribute("required") &&
          !this.senderNameInput.value.trim()
        ) {
          return this.setFieldError(
            this.senderNameInput,
            senderNameField,
            senderNameErrorMessage,
            "Sender name is required.",
          );
        } else if (this.senderNameInput.value.length > maxLength) {
          return this.setFieldError(
            this.senderNameInput,
            senderNameField,
            senderNameErrorMessage,
            `Sender name cannot exceed ${maxLength} characters.`,
          );
        } else {
          this.clearFieldError(
            this.senderNameInput,
            senderNameField,
            senderNameErrorMessage,
          );
          return true;
        }
      }

      initEmailSubjectValidation() {
        if (!this.emailSubjectInput) return;

        const emailSubjectField = this.emailSubjectInput.closest(".field");
        const emailSubjectErrorMessage =
          this.createErrorMessageSpan(emailSubjectField);
        const maxLength = 100;

        this.emailSubjectInput.addEventListener("blur", () => {
          this.validateEmailSubjectField();
        });

        this.emailSubjectInput.addEventListener("input", () => {
          if (
            this.emailSubjectInput.value.length <= maxLength &&
            (!this.emailSubjectInput.hasAttribute("required") ||
              this.emailSubjectInput.value.trim())
          ) {
            this.clearFieldError(
              this.emailSubjectInput,
              emailSubjectField,
              emailSubjectErrorMessage,
            );
          }
        });
      }

      validateEmailSubjectField() {
        if (!this.emailSubjectInput) return true;

        const emailSubjectField = this.emailSubjectInput.closest(".field");
        const emailSubjectErrorMessage =
          this.createErrorMessageSpan(emailSubjectField);
        const maxLength = 100;

        this.emailSubjectInput.setCustomValidity("");

        if (
          this.emailSubjectInput.hasAttribute("required") &&
          !this.emailSubjectInput.value.trim()
        ) {
          return this.setFieldError(
            this.emailSubjectInput,
            emailSubjectField,
            emailSubjectErrorMessage,
            "Email subject is required.",
          );
        } else if (this.emailSubjectInput.value.length > maxLength) {
          return this.setFieldError(
            this.emailSubjectInput,
            emailSubjectField,
            emailSubjectErrorMessage,
            `Email subject cannot exceed ${maxLength} characters.`,
          );
        } else {
          this.clearFieldError(
            this.emailSubjectInput,
            emailSubjectField,
            emailSubjectErrorMessage,
          );
          return true;
        }
      }

      // Helper methods for consistent error handling
      setFieldError(input, field, errorMessage, message) {
        input.setCustomValidity(message);
        errorMessage.textContent = message;
        field.classList.add("has-error");
        input.classList.add("invalid");
        input.setAttribute("aria-invalid", "true");
        return false;
      }

      clearFieldError(input, field, errorMessage) {
        input.setCustomValidity("");
        errorMessage.textContent = "";
        field.classList.remove("has-error");
        input.classList.remove("invalid");
        input.setAttribute("aria-invalid", "false");
      }

      clearValidationErrors() {
        const fields = [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.senderNameInput,
          this.emailSubjectInput,
        ].filter(Boolean);

        fields.forEach((input) => {
          const field = input.closest(".field");
          const errorMessage = field?.querySelector(".error-message");
          if (field && errorMessage) {
            this.clearFieldError(input, field, errorMessage);
          }
        });
      }

      createErrorMessageSpan(field) {
        let errorMessage = field?.querySelector(".error-message");
        if (!errorMessage) {
          errorMessage = document.createElement("span");
          errorMessage.className = "error-message";
          field?.appendChild(errorMessage);
        }
        return errorMessage;
      }
    },
  );
}
